<template>
  <div class="flex justify-center rounded-lg relative">
    <div class="md:w-8/12 lg:w-6/12">
      <div class="relative mt-3 z-50">
        <div class=""><landing-language-switcher /></div>
        <div class="m-2"><landing-price /></div>
      </div>
      <div
        class="container mx-auto px-4 p-1 bg-sub shadow-md drop-shadow-2xl lg:p-2 rounded-md place-items-center relative"
      >
        <!-- end of alert message -->
        <LPCarsoul :css="'h-28 md:h-72'" class="" />

        <p
          class="text-color text-center"
          :dir="authStore.getLandingPageLanguage == 'ar' ? 'rtl' : 'ltr'"
        >
          <template v-if="authStore.getLandingPageLanguage == 'en'">{{
            " Content available only in Arabic language"
          }}</template>
          <template v-if="authStore.getLandingPageLanguage == 'ar'">{{
            "المحتوى متوفر باللغة العربية فقط"
          }}</template>
        </p>
        <div class="">
          <LandingServiceName />
        </div>

        <div class="">
          <div class="mx-2">
            <landing-text />
          </div>

          <!-- <div  class="border border-b-2 border-pink-500  mx-2 mx-auto mt-1 w-36"></div> -->

          <div class="m-3 relative mx-auto flex justify-center" dir="rtl">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="h-6 w-6 absolute right-3 md:right-[15px] lg:right-28 top-2 rotate-230"
              fill="none"
              viewBox="0 0 24 24"
              stroke="white"
              stroke-width="1"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"
              />
            </svg>

            <input
              dir="ltr"
              type="number"
              class="bg-gray-900 border border-color focus:ring-pink-500 focus:border-pink-500 text-gray-900 text-sm rounded-sm w-full lg:w-10/12"
              v-model="phone"
              @keypress="acceptNumbersOnly($event)"
              @focus="chechkPhone"
              maxlength="12"
              placeholder="9715xxxxxxxx"
              lang="en"
              required
            />
          </div>

          <p
            v-if="error"
            class="text-red-500 text-center"
            :dir="authStore.getLandingPageLanguage == 'ar' ? 'rtl' : 'ltr'"
          >
            <template v-if="authStore.getLandingPageLanguage == 'en'">{{
              messageEN
            }}</template>
            <template v-if="authStore.getLandingPageLanguage == 'ar'">{{
              message
            }}</template>
          </p>

          <div
            class="flex justify-center flex-row my-3"
            :class="authStore.getLandingPageLanguage == 'ar' ? 'ml-3' : 'mr-2'"
            :dir="authStore.getLandingPageLanguage == 'ar' ? 'rtl' : 'ltr'"
          >
            <button
              type="submit"
              :disabled="isLoading"
              :class="{ 'cursor-not-allowed btn-color-disabled': isLoading }"
              class="flex justify-center text-white mx-2 focus:ring-0 focus:outline-none focus:ring-pink-300 rounded-lg md:text-md text-md md:px-6 w-full sm:w-auto px-2 py-1 my-1 text-center btn-color cursor-pointer w-btn absloute z-20"
              @click="subscribe"
              id="confirm_otp"
            >
              <template v-if="authStore.getLandingPageLanguage == 'en'"
                >SUBSCRIBE NOW</template
              >
              <template v-if="authStore.getLandingPageLanguage == 'ar'"
                >إشترك الآن!</template
              >
              <div role="status" v-show="isLoading">
                <svg
                  aria-hidden="true"
                  class="inline w-4 h-4 mr-2 text-gray-200 animate-spin dark:text-gray-600 fill-gray-600"
                  viewBox="0 0 100 101"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                    fill="currentColor"
                  />
                  <path
                    d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                    fill="currentFill"
                  />
                </svg>
                <span class="sr-only">Loading...</span>
              </div>
            </button>
            <button
              class="text-white mx-2 focus:ring-0 focus:outline-none focus:ring-pink-300 rounded-lg md:text-md text-md w-full md:px-16 sm:w-auto px-2 py-1 my-1 text-center border border-gray-100 cursor-pointer w-btn absloute z-20"
              @click="$router.push('/')"
            >
              <template v-if="authStore.getLandingPageLanguage == 'en'">EXIT </template>
              <template v-if="authStore.getLandingPageLanguage == 'ar'"> خروج</template>
            </button>
          </div>
          <div class="flex justify-center">
            <span class="text-white text-sm md:text-md relative z-50">
              <template v-if="authStore.getLandingPageLanguage == 'en'"
                >Already have an active subscription?
                <a href="/login" class="text-color"> Log in</a></template
              >
              <template v-if="authStore.getLandingPageLanguage == 'ar'">
                لديك إشتراك نشط بالفعل؟
                <a href="/login" class="text-color"> تسجيل الدخول </a></template
              >
            </span>
          </div>
          <div class="mx-2 text-sm">
            <landing-price />
          </div>

          <landing-terms />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import AuthCarsouel from "@/components/shared/AuthCarsouel.vue";

import { validatePhone } from "@/util/validation";
import { useAuthStore } from "@/stores/auth";
import { mapActions } from "pinia";
import LPCarsoul from "@/components/shared/LPCarsoul.vue";
import LandingPrice from "@/components/landingpage/LandingPrice.vue";
import LandingLanguageSwitcher from "@/components/landingpage/LandingLanguageSwitcher.vue";
import LandingServiceName from "@/components/landingpage/LandingServiceName.vue";
import LandingTerms from "@/components/landingpage/LandingTerms.vue";
import LandingText from "@/components/landingpage/LandingText.vue";
import { useToast } from "vue-toastification";
export default {
  components: {
    // AuthCarsouel,
    LPCarsoul,
    LandingPrice,
    LandingLanguageSwitcher,
    LandingServiceName,
    LandingTerms,
    LandingText,
  },
  data() {
    return {
      phone: "9715xxxxxxxx",

      error: false,
      isLoading: false,
      show: false,
      messageAr: "",
      messageEn: "",
      bgColor: "bg-green-600",
      authStore: useAuthStore(),
      toast: useToast(),
    };
  },
  watch: {
    async phone(newValue, oldValue) {
      if (newValue.length < 4) this.phone = "9715";
      if (isNaN(newValue)) this.phone = oldValue;
    },
  },
  methods: {
    ...mapActions(useAuthStore, ["subscribeAction"]),
    acceptNumbersOnly(event) {
      var numberRegex = /^(?:-(?:[1-9](?:\d{0,2}(?:,\d{3})+|\d*))|(?:0|(?:[1-9](?:\d{0,2}(?:,\d{3})+|\d*))))(?:.\d+|)$/;
      if (numberRegex.test(event.target.value)) {
        return true;
      } else {
        event.preventDefault();
      }
    },
    chechkPhone(event) {
      if (this.phone.toString().startsWith("9715x")) {
        this.phone = "9715";

        return this.phone;
      } else {
        this.phone = event.target.value;
      }

      return this.phone;
    },
    async subscribe() {
      if (this.phone.toString().startsWith("9715x") || this.phone.length > 12)
        return false;
      if (validatePhone(this.phone.toString().trim()).valid) {
        this.error = false;

        const loginToastID = this.toast.loading("تحميل...", {
          rtl: true,
          position: this.toast.POSITION.BOTTOM_RIGHT,
          onOpen: () => (this.isLoading = true),
        });
        /**
         * subscribe end point for getting the url
         * */
        await this.subscribeAction(
          validatePhone(this.phone.toString().trim()).phoneNumber
        ).then((response) => {
          this.redirect(response, loginToastID);
        });
      } else {
        this.error = true;
        return false;
      }
    }, //end of subscrbtion method

    close() {
      return (this.error = false);
    },

    redirect(response) {
      if (response.data.success) {
        this.show = true;
        this.messageAr = "تم إرسال رمز التحقق بنجاح";
        this.messageEn = "Verification code sent successfully";

        setTimeout(() => {
          this.show = false;
          this.$router.push({ name: "verify.otp" });
        }, 2000);
      } else if (response.data.success == true && response.data.isActive == true) {
        this.show = true;
        this.messageAr = "أنت مشترك بالفعل";
        this.messageEn = "You are already subscribed";
        if (this.authStore.getLandingPageLanguage == "ar") {
          this.toast.success(this.messageAr);
        } else {
          this.toast.success(this.messageEn);
        }
        setTimeout(() => {
          this.show = false;
          this.$router.push({ name: "success" });
        }, 2000);
      } else {
        this.show = true;
   
        this.messageAr = "فشل العمليه";
        this.messageEn = "subscription failed";
        if (this.authStore.getLandingPageLanguage == "ar") {
          this.toast.error(this.messageAr);
        } else {
          this.toast.error(this.messageEn);
        }
        setTimeout(() => {
          this.show = false;
          this.$router.push({ name: "failed" });
        }, 2000);
      }
    },
    // cancel method redirect user to the home page
    cancel() {
      this.$router.push({ name: "home" });
    },
  },
  
};
</script>

<style scoped>
.width-height {
  width: 900px;
  height: auto;
}

.xxsm {
  width: 255px;
}

.w-btn {
  /* width: 290px; */
  align-self: right;
}

.btn-color {
  background-color: #9d2890;
}

.btn-color-disabled {
  background-color: #802e76;
}

.bg-sub {
  background-color: #181b30;
}

input {
  text-align: center;
  outline: none;
  padding-left: 5px;
  color: aliceblue;
}

::-webkit-input-placeholder {
  text-align: center;
}

:-moz-placeholder {
  text-align: center;
}

.font-small {
  font-size: 16px;
}
</style>
